//Modification provided by the Searchanise team, with any questions, contact us at feedback@searchanise.io
//
// CONFIGURATION
// To add or remove tags, edit the VIEW_PRODUCT_TAGS set below.
// Products with any of these tags will show "View Product" button instead of "Add to Cart".
//
// NOTE: Each tag must be followed by a comma, except for the last one.
//
// Example:
// const VIEW_PRODUCT_TAGS = new Set([
//     'no_cart',
//     'pre_order',
//     'coming_soon'
// ]);

const VIEW_PRODUCT_TAGS = new Set([
    'no_cart'
]);

// --- DO NOT EDIT BELOW THIS LINE ---
document.addEventListener('Searchanise.Loaded', function() {
    (function($) {
        function replaceButton(product,productData) {
            const tags = productData.tags.toLowerCase().split('[:attr:]').map(t => t.trim());
            const shouldReplace = tags.some(tag => VIEW_PRODUCT_TAGS.has(tag));
            
            if (shouldReplace && $('.snize-add-to-cart-button', product).length) {
                $('.snize-add-to-cart-button', product)
                    .removeClass('snize-add-to-cart-button')
                    .addClass('snize-view-product-button')
                    .text(Searchanise.GetWidgets().options.LabelResultsViewProduct);
            }
        }
        $(document).on('Searchanise.ResultsUpdated', function(event, container) {
            $('.snize-product', container).each(function() {
               let product = $(this);
               let productData = $(this).data('snize_item_data');
               replaceButton(product,productData);
            });
        });
    })(window.Searchanise.$);
});